export function transformBooleanInputValue(value: string | boolean): boolean {
  return typeof value === 'string' ? value === '' : value;
}
